import React from "react";

/** Branding fields. Saves through the shared settings payload in Settings.js. */
export default function GeneralSettings({
  mainTitle,
  setMainTitle,
  subTitle,
  setSubTitle,
  onSave,
  saving,
}) {
  return (
    <>
      <h5 className="settings-section-title">Branding</h5>
      <p className="settings-section-sub">
        Shown on the login screen, the top bar, and printed slips.
      </p>

      <div className="input-grid">
        <div className="input-box">
          <label>Main Title</label>
          <input
            type="text"
            value={mainTitle}
            onChange={(e) => setMainTitle(e.target.value)}
          />
        </div>

        <div className="input-box">
          <label>Sub Title</label>
          <input
            type="text"
            value={subTitle}
            onChange={(e) => setSubTitle(e.target.value)}
          />
        </div>
      </div>

      <button className="save-btn" onClick={onSave} disabled={saving}>
        {saving ? "Saving..." : "Save Changes"}
      </button>
    </>
  );
}
